"use client";

// Decodes encoded audio bytes into an AudioBuffer: the MP3 from a full render (to seed the splice base) and the WAV slice from a segment render. Mirrors extractAudioSegment's AudioContext lifecycle.
export const decodeAudioArrayBuffer = async (
  arrayBuffer: ArrayBuffer
): Promise<AudioBuffer> => {
  const audioContext = new AudioContext();
  try {
    return await audioContext.decodeAudioData(arrayBuffer);
  } finally {
    await audioContext.close();
  }
};
